import Lottie from 'lottie-react';
import loaderAnimation from "../../assets/lottie/Load.json";

const SplashScreen = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Lottie
        animationData={loaderAnimation}
        loop={true}
        style={{ width: 180, height: 180 }}
      />
    </div>
  )
}

export default SplashScreen